import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'delete'
})
export class DeletePipe implements PipeTransform {
    transform(items: any[], index: number) {
        if (index && items) {
            items.splice(index, 1);
        }
        return items;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sui/sui.util/sui.util.delete.pipe.ts